/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'boxes',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M472,272h-32V168c0-4.418-3.582-8-8-8H288c-4.418,0-8,3.582-8,8v104h-32c-4.418,0-8,3.582-8,8v192c0,4.418,3.582,8,8,8
			h224c4.418,0,8-3.582,8-8V280C480,275.582,476.418,272,472,272z M344,176h32v32h-32V176z M296,176h32v40c0,4.418,3.582,8,8,8h48
			c4.418,0,8-3.582,8-8v-40h32v96H296V176z M384,288v96h-48v-96H384z M464,464H256V288h64v104c0,4.418,3.582,8,8,8h64
      c4.418,0,8-3.582,8-8V288h64V464
      
      M216,0H8C3.582,0,0,3.582,0,8v464c0,4.418,3.582,8,8,8h208c4.418,0,8-3.582,8-8V8C224,3.582,220.418,0,216,0z M88,16h48
      v96H88V16z M208,464H16V16h56v104c0,4.418,3.582,8,8,8h64c4.418,0,8-3.582,8-8V16h56V464
      
      ${utils.rect(40, 432, 64, 16)}

      M88,356.688 L68,376.688 L48,356.688 L26.344,378.344 L37.656,389.656 L40,387.312 L40,416 L56,416 L56,387.312 
			L58.344,389.656 L68,380 L77.656,389.656 L80,387.312 L80,416 L96,416 L96,387.312 L98.344,389.656 L109.656,378.344
      
      M144,400v48h48v-48H144z M176,432h-16v-16h16V432

      ${utils.rect(128, 368, 16, 16)}

      ${utils.rect(160, 368, 32, 16)}

      ${utils.rect(128, 336, 64, 16)}

      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/boxes.js